import { Modal } from "antd";

/** 与后端 CreateStoreOrderResult.CREATE_RESULT_DUPLICATE_UNPAID 一致 */
export const STORE_ORDER_CREATE_RESULT_DUPLICATE_UNPAID = 506;

export type DuplicateUnpaidOrderAction = "new" | "pay";

const DUPLICATE_UNPAID_MSG = "您已经有一个相同产品的订单尚未支付，确定要新建订单吗？";

/** 左：新建订单；右：前往支付 */
export function promptDuplicateUnpaidOrder(
  messageText: string = DUPLICATE_UNPAID_MSG
): Promise<DuplicateUnpaidOrderAction> {
  return new Promise((resolve) => {
    Modal.confirm({
      title: null,
      icon: null,
      content: messageText,
      width: 400,
      centered: true,
      maskClosable: false,
      closable: false,
      className: "lf-modal-square",
      cancelText: "新建订单",
      okText: "前往支付",
      onCancel: () => resolve("new"),
      onOk: () => resolve("pay"),
    });
  });
}

export function isDuplicateUnpaidCreateResult(res: {
  createResult: number;
  existingOrderId?: string | null;
}): res is { createResult: typeof STORE_ORDER_CREATE_RESULT_DUPLICATE_UNPAID; existingOrderId: string } {
  return (
    res.createResult === STORE_ORDER_CREATE_RESULT_DUPLICATE_UNPAID &&
    Boolean(res.existingOrderId?.trim())
  );
}
